<template>

</template>

<script>
    export default {

        //Mounted event, data initiations
        created() {
            
            var usr = JSON.parse( this.usr );
            var favs = JSON.parse( this.f );
            var rfavs = JSON.parse( this.rf );

            usr.favs = favs;
            usr.rfavs = rfavs;

            this.setUser( usr );
            this.$store.state.user = usr;

        },

        mounted() {

        },

        //Data Passed by laravel from blade templates
        props : ['usr','f','rf'],

        //Variables go here
        data() {
            return {
                auth_usr : false,
            }
        },

        components : {},

        //Methods accessable by template
        methods : {

        },

        //The result is cached so calculations will occur only when needed
        computed : {},

        //Filters
        filters : {},

        //Watch property changes
        watch : {}

    }
</script>